import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';

@Component({
  selector: 'app-bpg-membership-preview-success',
  templateUrl: './bpg-membership-preview-success.component.html',
  styleUrls: ['./bpg-membership-preview-success.component.css']
})
export class BpgMembershipPreviewSuccessComponent implements OnInit {

  constructor(private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    private bpgCommonService : BpgCommonService
    ) { }

  ngOnInit() {

    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    },500);
    
    // setTimeout(function(){
    //   window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    //   this.spinnerService.show();
    // }.bind(this),2000);  
        
    setTimeout(function() { 
      // this.bpgCommonService.isSiteOrBpgCreated.next(true);            
      this.router.navigate(['/user-membership']);  
      // this.spinnerService.hide();
    }.bind(this), 3000); 
  }
  
}
